/** @format */
import React from 'react';

export default () => {
    // This will eventually replace the php version of the confirmation page
    return null;
};
